export interface IAuthService {
  logout: () => Promise<void>
  signIn: (body: IAuth) => Promise<any>
  refreshToken: (token: string) => Promise<void>
  registerAccessToken: (token: string | string[]) => void
  registerRefreshToken: (token: string | string[]) => void
}

export interface IAuth {
  username: string
  password: string
  "cf-turnstile-response"?: string
}

export type LogoutResponse = {
  user: boolean
}

export type LoginResponseWithTwoFactor = {
  mfa: true
}

export type LoginResponseDefault = {
  avatar: string
  username: string
  mfa?: false
}

export type LoginResponse = LoginResponseWithTwoFactor | LoginResponseDefault

// Type guard to check if response is MFA required
export function isLoginResponseWithMFA(response: LoginResponse): response is LoginResponseWithTwoFactor {
  return "mfa" in response && response.mfa === true
}
